export const onDone = creds => ({
  widget: 'users',
  type: 'onDone',
  payload: { creds },
})



// WEBPACK FOOTER //
// ./src/users/actions/onDone.js